<template>
  <div class="animated fadeIn">

    <b-card class="mt-2">
      <h2>My Messages</h2>
      <div class="lead">Respond to customer messages and interact with your customers directly through their replies to your advertisements</div>
    </b-card>

    <b-card v-loading="loading">
      <h4>
        All Messages
        <b-button-toolbar class="pull-right">
          <b-form-radio-group buttons button-variant="outline-secondary" v-model="view">
            <b-form-radio value="all">All</b-form-radio>
            <b-form-radio value="unread">Unread</b-form-radio>
            <b-form-radio value="active">Active</b-form-radio>
            <b-form-radio value="resolved">Resolved</b-form-radio>
          </b-form-radio-group>
        </b-button-toolbar>
      </h4>

      <b-table v-if="conversations.length > 0" striped hover :items="conversations" :fields="fields" :sort-compare="sortCompare" class="mt-4 mb-0">
        <template slot="message" slot-scope="data">
          <span v-for="message in data.item.messages" :key="message.postedAt">
            {{message.text.length > 80 ? message.text.slice(0, 77).trim() + '...' : message.text}}
          </span>
        </template>
        <template slot="customer" slot-scope="data">
          {{data.item.customer.name}}
        </template>
        <template slot="publisher" slot-scope="data">
          <b-button variant="outline" size="sm" @click="viewMessage(data.item)">
            <img src="/img/publishers/kijiji.png" height="20" alt="Kijiji" /></b-button>
        </template>
        <template slot="status" slot-scope="data">
          <b-badge v-if="data.item.status === 'unread'" variant="success" class="py-1 px-2">UNREAD</b-badge>
          <b-badge v-if="data.item.status === 'active'" variant="warning" class="py-1 px-2">ACTIVE</b-badge>
          <b-badge v-if="data.item.status === 'resolved'" variant="secondary" class="py-1 px-2">RESOLVED</b-badge>
        </template>
        <template slot="lastUpdated" slot-scope="data">
          {{moment(data.item.messages[0].postedAt).fromNow()}}
        </template>
        <template slot="actions" slot-scope="data">
          <b-button-group>
            <b-button variant="primary" size="sm" :to="`/messages/${data.item.id}/edit`">View</b-button>
          </b-button-group>
        </template>
      </b-table>
      <b-alert :show="conversations.length === 0" variant="info" class="mt-4 mb-0 py-3 px-3 d-flex align-items-center">
        <i class="icon-info mr-2"></i>
        <div>You have no messages at this time. Great job!</div>
      </b-alert>
    </b-card>
  </div>
</template>

<script>
import moment from 'moment'

const fields = {
  'publisher': {
    label: 'Publisher',
    class: 'text-center',
    thStyle: { width: '120px' }
  },
  'message': {
    label: 'Message',
  },
  'customer': {
    label: 'Customer',
    class: 'text-center',
    sortable: true,
  },
  'lastUpdated': {
    label: 'Last Updated',
    class: 'text-center',
    sortable: true,
  },
  'status': {
    label: 'Status',
    class: 'text-center',
    thStyle: { width: '100px' }
  },
  'actions': {
    label: 'Actions',
    class: 'text-center',
    thStyle: { width: '100px' }
  }
}

export default {
  name: 'ConversationsIndex',

  data(){
    return {
      fields,
      conversations : [],

      // State
      view    : 'all',
      loading : false,
      error   : ''
    }
  },

  mounted(){
    this.load()
  },

  methods: {
    moment,

    load(){
      this.loading = true
      this.$API.v2.Messages.ListConversations()
      .then((conversations) => {
        this.conversations = conversations
      })
      .catch((err) => {
        this.error = err
      })
      .then(() => {
        this.loading = false
      })
    },

    viewMessage(convo){
      switch( convo.publisher ){
        case 'kijiji':
          window.open(`https://www.kijiji.ca/m-msg-my-messages/conversation/${convo.id.replace(/^kijiji:/i, '')}`)
        return
      }
    },

    sortCompare(a, b, key){
      if( key === 'lastUpdated' ){
        a = moment(a.messages[0].postedAt)
        b = moment(b.messages[0].postedAt)
        return a.isBefore(b) ? -1 : a.isSame(b) ? 0 : 1
      }

      // Default sort
      if (typeof a[key] === 'number' && typeof b[key] === 'number') {
        // If both compared fields are native numbers
        return a[key] < b[key] ? -1 : (a[key] > b[key] ? 1 : 0)
      }
      else {
        // Stringify the field data and use String.localeCompare
        return String(a[key]).localeCompare(toString(b[key]), undefined, {
          numeric: true
        })
      }
    }
  }
};
</script>
